// extracted by mini-css-extract-plugin
export default {"rightAlign":"entities_rightAlign__yYCrQ","capitalize":"entities_capitalize__PpEFc","uppercase":"entities_uppercase__rEnDc","alignBottom":"entities_alignBottom__-z78P"};